import React, { useState } from 'react';
import { Navigate, Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import CircularProgress from '@mui/material/CircularProgress';
import SportsRoundedIcon from '@mui/icons-material/SportsRounded';
import SportsHandballRoundedIcon from '@mui/icons-material/SportsHandballRounded';
import { useAuth } from '../../AuthContext';
import tokens from '../../theme/tokens';

const TEXTOS = {
  arbitro: { titulo: 'Acesso do árbitro', descricao: 'Use o login criado pela diretoria. Faça o check-in na pelada e apite as partidas.', destino: '/arbitro', perfis: ['Arbitro', 'Admin', 'Diretor'] },
  goleiro: { titulo: 'Acesso do goleiro', descricao: 'Use o login criado pela diretoria para fazer o check-in na pelada em que você está escalado.', destino: '/goleiro', perfis: ['Goleiro'] },
};

// Login de árbitro ou goleiro (coleções próprias na API).
const ArbitroLogin = ({ papel = 'arbitro' }) => {
  const { isAuthenticated, userLogado, loginArbitro, loginGoleiro } = useAuth();
  const texto = TEXTOS[papel];
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  if (isAuthenticated && texto.perfis.includes(userLogado?.perfil)) {
    return <Navigate to={texto.destino} />;
  }

  const entrar = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    const resposta = await (papel === 'goleiro' ? loginGoleiro : loginArbitro)(login, senha);
    if (!resposta.isAuthenticated) setErro(resposta.message);
    setCarregando(false);
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, background: `radial-gradient(circle at 50% 0%, rgba(215,38,61,0.3), transparent 55%), linear-gradient(160deg, ${tokens.color.inkSoft}, ${tokens.color.ink})` }}>
      <Card component="form" onSubmit={entrar} sx={{ width: '100%', maxWidth: 400, p: { xs: 3, sm: 4 } }}>
        <Stack alignItems="center" spacing={1} sx={{ mb: 3 }}>
          <Box sx={{ width: 64, height: 64, borderRadius: '50%', bgcolor: tokens.color.brandSoft, color: tokens.color.brand, display: 'grid', placeItems: 'center' }}>
            {papel === 'goleiro' ? <SportsHandballRoundedIcon sx={{ fontSize: 36 }} /> : <SportsRoundedIcon sx={{ fontSize: 36 }} />}
          </Box>
          <Typography variant="h5">{texto.titulo}</Typography>
          <Typography variant="body2" color="text.secondary" align="center">{texto.descricao}</Typography>
        </Stack>
        <Stack spacing={2}>
          <TextField label="Login" value={login} onChange={(e) => setLogin(e.target.value)} autoCapitalize="none" autoComplete="username" fullWidth autoFocus />
          <TextField label="Senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} autoComplete="current-password" fullWidth />
          {erro && <Alert severity="error">{erro}</Alert>}
          <Button type="submit" variant="contained" size="large" disabled={carregando || !login || !senha}>
            {carregando ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
          </Button>
          <Typography variant="body2" align="center" color="text.secondary">
            É jogador? <Link component={RouterLink} to="/login">Entrar como jogador</Link>
          </Typography>
        </Stack>
      </Card>
    </Box>
  );
};

export default ArbitroLogin;
